// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDataGrid-columnHeaders .MuiSvgIcon-root {
  color: white !important;
}

.MuiDataGrid-footerContainer {
  border-top: none !important;
}

.MuiDataGrid-cell:focus {
  outline: none !important;
}

div > svg[data-testid=CloseIcon] {
  color: #e81d2c !important;
}

div > svg[data-testid=CheckIcon] {
  color: #098442 !important;
}

.MuiPickersPopper-paper {
  position: relative !important;
  top: 56px !important;
}

.MuiDataGrid-menu {
  z-index: 5000 !important;
}

.MuiDataGrid-panel {
  z-index: 5001 !important;
}

.MuiDataGrid-cell {
  border: 1px solid transparent !important;
}

.MuiDataGrid-cell:hover {
  color: #098442;
}

.MuiDataGrid-row:hover {
  border: 1px solid #098442 !important;
}

/* Fix for black lines between table items */
.MuiTableCell-root {
  border-bottom: none !important;
}

body {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  font-family: "Roboto", sans-serif;
}

input, select, textarea, button {
  font-family: inherit;
}

#root {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}

/* Flexbox */
.flx1 {
  display: flex !important;
  flex: 1 !important;
}

.flx2 {
  display: flex !important;
  flex: 2 !important;
}

.flx3 {
  display: flex !important;
  flex: 3 !important;
}

.flx4 {
  display: flex !important;
  flex: 4 !important;
}

.flx5 {
  display: flex !important;
  flex: 5 !important;
}

.fdr {
  display: flex !important;
  flex-direction: row !important;
  min-width: 0 !important;
}

.fdc {
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
}

.fdrr {
  display: flex !important;
  flex-direction: row-reverse !important;
}

.fdcr {
  display: flex !important;
  flex-direction: column-reverse !important;
}

.fww {
  display: flex !important;
  flex-wrap: wrap !important;
}

.aifs {
  display: flex !important;
  align-items: flex-start !important;
}

.aic {
  display: flex !important;
  align-items: center !important;
}

.aife {
  display: flex !important;
  align-items: flex-end !important;
}

.ais {
  display: flex !important;
  align-items: stretch !important;
}

.jcfs {
  display: flex !important;
  justify-content: flex-start !important;
}

.jcc {
  display: flex !important;
  justify-content: center !important;
}

.jcr {
  display: flex !important;
  justify-content: right !important;
}

.jcfe {
  display: flex !important;
  justify-content: flex-end !important;
}

.jcsa {
  display: flex !important;
  justify-content: space-around !important;
}

.jcsb {
  display: flex !important;
  justify-content: space-between !important;
}

.jcse {
  display: flex !important;
  justify-content: space-evenly !important;
}

.asc {
  display: flex !important;
  align-self: center !important;
}

.wsnw {
  white-space: nowrap !important;
}

.tac {
  text-align: center !important;
}

.cursorPointer {
  cursor: pointer !important;
}

.tdus {
  text-decoration: unset !important;
}

.gc2 {
  display: grid;
  grid-template-columns: auto auto;
}

.gc3 {
  display: grid;
  grid-template-columns: auto auto auto;
}

.gc4 {
  display: grid;
  grid-template-columns: auto auto auto auto;
}

/* Borders */
.bwn {
  border: none !important;
}

.bw1 {
  border: 1px solid !important;
}

.brw1 {
  border-width: 0 1px 0 0;
  border-style: solid !important;
}

.bbw1 {
  border-width: 0 0 1px 0;
  border-style: solid !important;
}

.bbw2 {
  border-bottom-width: 2px;
}

.bocp {
  border-color: #0d703f;
}

.bocg0 {
  border-color: #eaeaea;
}

.bocg3 {
  border-color: #424242;
}

.bocw {
  border-color: white !important;
}

.bocDarkBlue {
  border-color: #052E5C !important;
}

.bocGrey {
  border-color: #CECECE !important;
}

.bocWhite {
  border-color: white !important;
}

.brh {
  border-radius: 50% !important;
}

.br0 {
  border-radius: 0px !important;
}

.br4 {
  border-radius: 4px !important;
}

.br5 {
  border-radius: 5px !important;
}

.br10 {
  border-radius: 10px !important;
}

.br15 {
  border-radius: 15px !important;
}

.br16 {
  border-radius: 16px !important;
}

.br17 {
  border-radius: 17px !important;
}

.br20 {
  border-radius: 20px !important;
}

.br25 {
  border-radius: 25px !important;
}

.br40 {
  border-radius: 40px !important;
}

.br50 {
  border-radius: 50px !important;
}

.pbr {
  border-radius: 4px 4px 0px 0px;
}

/* Dimensions */
.wfill {
  width: 100% !important;
}

.wfillMinusScroll {
  width: calc(100% - 8.5px) !important;
}

.w0 {
  width: 0 !important;
}

.w1 {
  width: 1px !important;
}

.w2 {
  width: 2px !important;
}

.w3 {
  width: 3px !important;
}

.w5 {
  width: 5px !important;
}

.w10 {
  width: 10px !important;
}

.w20 {
  width: 20px !important;
}

.w23 {
  width: 23px !important;
}

.w30 {
  width: 30px !important;
}

.w37 {
  width: 37px !important;
}

.w40 {
  width: 40px !important;
}

.w42 {
  width: 42px !important;
  min-width: 42px !important;
}

.w45 {
  width: 45px !important;
  min-width: 45px !important;
}

.w50 {
  width: 50px !important;
}

.w56 {
  width: 56px !important;
  min-width: 56px !important;
}

.w60 {
  width: 60px !important;
  min-width: 60px !important;
}

.w65 {
  width: 65px !important;
  min-width: 65px !important;
}

.w77 {
  width: 77px !important;
  min-width: 77px !important;
}

.w100 {
  width: 100px !important;
}

.w120 {
  width: 120px !important;
}

.w150 {
  width: 150px !important;
}

.w172 {
  width: 172px !important;
}

.w180 {
  width: 180px !important;
}

.maw180 {
  max-width: 180px !important;
}

.w200 {
  width: 200px !important;
}

.w205 {
  width: 205px !important;
}

.w240 {
  width: 240px !important;
}

.w250 {
  width: 250px !important;
}

.w290 {
  width: 290px !important;
}

.w300 {
  width: 300px !important;
}

.w320 {
  width: 320px !important;
}

.w338 {
  width: 338px !important;
}

.w350 {
  width: 350px !important;
}

.w400 {
  width: 400px !important;
}

.w500 {
  width: 500px !important;
}

.w600 {
  width: 600px !important;
}

.w700 {
  width: 700px !important;
}

.w800 {
  width: 800px !important;
}

.w804 {
  width: 804px !important;
}

.w900 {
  width: 900px !important;
}

.w1000 {
  width: 1000px !important;
}

.w1200 {
  width: 1200px !important;
}

.w1500 {
  width: 1500px !important;
}

.mw0 {
  min-width: 40px !important;
}

.mw40 {
  min-width: 40px !important;
}

.mw100 {
  min-width: 100px !important;
}

.mw160 {
  min-width: 160px !important;
}

.mw200 {
  min-width: 200px !important;
}

.mw300 {
  min-width: 300px !important;
}

.mw600 {
  min-width: 600px !important;
}

.mw800 {
  min-width: 800px !important;
}

.mw900 {
  min-width: 900px !important;
}

.hfill {
  height: 100% !important;
}

.hauto {
  height: auto !important;
}

.h0 {
  height: 0 !important;
}

.mh0 {
  min-height: 0 !important;
}

.h2 {
  height: 2px !important;
}

.h3 {
  height: 3px !important;
}

.mnh4 {
  min-height: 4px !important;
}

.h6 {
  height: 6px !important;
}

.h10 {
  height: 10px !important;
}

.h20 {
  height: 20px !important;
}

.h23 {
  height: 23px !important;
}

.mnh20 {
  min-height: 20px !important;
}

.mnh24 {
  min-height: 24px !important;
}

.h30 {
  height: 30px !important;
}

.h31 {
  height: 31px !important;
}

.h32 {
  height: 32px !important;
}

.mnh32 {
  min-height: 32px !important;
}

.h35 {
  height: 35px !important;
}

.h37 {
  height: 37px !important;
}

.h40 {
  height: 40px !important;
}

.h42 {
  height: 42px !important;
}

.h48 {
  height: 48px !important;
}

.mnh48 {
  min-height: 48px !important;
}

.h50 {
  height: 50px !important;
}

.h52 {
  height: 52px !important;
  min-height: 52px !important;
}

.mxh52 {
  max-height: 52px !important;
}

.mnh55 {
  min-height: 55px !important;
}

.h60 {
  height: 60px !important;
}

.mnh65 {
  min-height: 65px !important;
}

.h70 {
  height: 70px !important;
}

.mnh100 {
  min-height: 100px !important;
}

.h120 {
  height: 120px !important;
}

.mh135 {
  min-height: 135px !important;
}

.h138 {
  height: 138px !important;
}

.mxh120 {
  max-height: 120px !important;
}

.h150 {
  height: 150px !important;
}

.h155 {
  height: 155px !important;
}

.h200 {
  height: 200px !important;
}

.mh200 {
  min-height: 200px !important;
}

.h240 {
  height: 240px !important;
}

.mnh200 {
  min-height: 200px !important;
}

.mxh200 {
  max-height: 200px !important;
}

.h250 {
  height: 250px !important;
}

.mnh250 {
  min-height: 250px !important;
}

.h260 {
  height: 260px !important;
}

.h225 {
  height: 225px !important;
}

.h265 {
  height: 265px !important;
}

.h275 {
  height: 275px !important;
}

.mxh300 {
  max-height: 300px !important;
}

.mnh350 {
  min-height: 350px !important;
}

.h400 {
  height: 400px !important;
}

.mxh400 {
  max-height: 400px !important;
}

.mxhi {
  max-height: inherit !important;
}

.h800 {
  height: 800px !important;
}

.mxh600 {
  max-height: 600px !important;
}

.h1132 {
  height: 1132px;
}

.m5 {
  margin: 5px !important;
}

.m10 {
  margin: 10px !important;
}

.m20 {
  margin: 20px !important;
}

.m50 {
  margin: 50px !important;
}

.ml4 {
  margin-left: 4px !important;
}

.ml7 {
  margin-left: 7px !important;
}

.ml10 {
  margin-left: 10px !important;
}

.ml15 {
  margin-left: 15px !important;
}

.ml17 {
  margin-left: 17px !important;
}

.ml20 {
  margin-left: 20px !important;
}

.ml25 {
  margin-left: 25px !important;
}

.ml30 {
  margin-left: 30px !important;
}

.ml38 {
  margin-left: 38px !important;
}

.ml40 {
  margin-left: 40px !important;
}

.ml50 {
  margin-left: 50px !important;
}

.ml240 {
  margin-left: 240px !important;
}

.mr4 {
  margin-right: 4px !important;
}

.mr5 {
  margin-right: 5px !important;
}

.mr7 {
  margin-right: 7px !important;
}

.mr8 {
  margin-right: 8px !important;
}

.mr10 {
  margin-right: 10px !important;
}

.mr15 {
  margin-right: 15px !important;
}

.mr16 {
  margin-right: 16px !important;
}

.mr17 {
  margin-right: 17px !important;
}

.mr18 {
  margin-right: 18px !important;
}

.mr20 {
  margin-right: 20px !important;
}

.mr25 {
  margin-right: 25px !important;
}

.mr30 {
  margin-right: 30px !important;
}

.mr40 {
  margin-right: 40px !important;
}

.mr50 {
  margin-right: 50px !important;
}

.mr240 {
  margin-right: 240px !important;
}

.mrnlc15:not(:last-child) {
  margin-right: 15px !important;
}

.mt5 {
  margin-top: 5px !important;
}

.mt8 {
  margin-top: 8px !important;
}

.mt9 {
  margin-top: 9px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt12 {
  margin-top: 12px !important;
}

.mt14 {
  margin-top: 14px !important;
}

.mt15 {
  margin-top: 15px !important;
}

.mt16 {
  margin-top: 16px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt21 {
  margin-top: 21px !important;
}

.mt23 {
  margin-top: 23px !important;
}

.mt26 {
  margin-top: 26px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt40 {
  margin-top: 40px !important;
}

.mt50 {
  margin-top: 50px !important;
}

.mt240 {
  margin-top: 240px !important;
}

.mbm16 {
  margin-bottom: -16px !important;
}

.mb1 {
  margin-bottom: 1px !important;
}

.mb5 {
  margin-bottom: 5px !important;
}

.mb3 {
  margin-bottom: 3px !important;
}

.mb8 {
  margin-bottom: 8px !important;
}

.mb10 {
  margin-bottom: 10px !important;
}

.mb12 {
  margin-bottom: 12px !important;
}

.mb13 {
  margin-bottom: 13px !important;
}

.mb15 {
  margin-bottom: 15px !important;
}

.mb20 {
  margin-bottom: 20px !important;
}

.mb30 {
  margin-bottom: 30px !important;
}

.mb40 {
  margin-bottom: 40px !important;
}

.mb50 {
  margin-bottom: 50px !important;
}

.mb60 {
  margin-bottom: 60px !important;
}

.mb70 {
  margin-bottom: 70px !important;
}

.mb145 {
  margin-bottom: 145px !important;
}

.mb240 {
  margin-bottom: 240px !important;
}

.p0 {
  padding: 0 !important;
}

.p1 {
  padding: 1px !important;
}

.p5 {
  padding: 5px !important;
}

.p10 {
  padding: 10px !important;
}

.p12 {
  padding: 12px !important;
}

.p15 {
  padding: 15px !important;
}

.p20 {
  padding: 20px !important;
}

.p30 {
  padding: 30px !important;
}

.p40 {
  padding: 30px !important;
}

.p50 {
  padding: 50px !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pr5 {
  padding-right: 5px !important;
}

.pr10 {
  padding-right: 10px !important;
}

.pr15 {
  padding-right: 15px !important;
}

.pr20 {
  padding-right: 20px !important;
}

.pr24 {
  padding-right: 24px !important;
}

.pr25 {
  padding-right: 25px !important;
}

.pr30 {
  padding-right: 30px !important;
}

.pr36 {
  padding-right: 36px !important;
}

.pr50 {
  padding-right: 50px !important;
}

.pr80 {
  padding-right: 80px !important;
}

.pr109 {
  padding-right: 109px !important;
}

.pl0 {
  padding-left: 0px !important;
}

.pl1 {
  padding-left: 1px !important;
}

.pl2 {
  padding-left: 2px !important;
}

.pl5 {
  padding-left: 5px !important;
}

.pl10 {
  padding-left: 10px !important;
}

.pl15 {
  padding-left: 15px !important;
}

.pl20 {
  padding-left: 20px !important;
}

.pl25 {
  padding-left: 25px !important;
}

.pl30 {
  padding-left: 30px !important;
}

.pl50 {
  padding-left: 50px !important;
}

.pl80 {
  padding-left: 80px !important;
}

.pl109 {
  padding-left: 109px !important;
}

.pt3 {
  padding-top: 3px !important;
}

.pt5 {
  padding-top: 5px !important;
}

.pt8 {
  padding-top: 8px !important;
}

.pt10 {
  padding-top: 10px !important;
}

.pt15 {
  padding-top: 15px !important;
}

.pt16 {
  padding-top: 16px !important;
}

.pt20 {
  padding-top: 20px !important;
}

.pt28 {
  padding-top: 28px !important;
}

.pt30 {
  padding-top: 30px !important;
}

.pt50 {
  padding-top: 50px !important;
}

.pb0 {
  padding-bottom: 0px !important;
}

.pb3 {
  padding-bottom: 3px !important;
}

.pb4 {
  padding-bottom: 4px !important;
}

.pb5 {
  padding-bottom: 5px !important;
}

.pb7 {
  padding-bottom: 7px !important;
}

.pb8 {
  padding-bottom: 8px !important;
}

.pb10 {
  padding-bottom: 10px !important;
}

.pb15 {
  padding-bottom: 15px !important;
}

.pb16 {
  padding-bottom: 16px !important;
}

.pb20 {
  padding-bottom: 20px !important;
}

.pb24 {
  padding-bottom: 24px !important;
}

.pb28 {
  padding-bottom: 28px !important;
}

.pb30 {
  padding-bottom: 30px !important;
}

.pb50 {
  padding-bottom: 50px !important;
}

.oh {
  overflow: hidden !important;
}

.oyh {
  overflow-y: hidden !important;
}

.oys {
  overflow-y: scroll !important;
}

.oya {
  overflow-y: auto !important;
}

.oxs {
  overflow-x: scroll !important;
}

.oxh {
  overflow-x: hidden !important;
}

.ov {
  overflow: visible !important;
}

.oa {
  overflow: auto !important;
}

.oyo {
  overflow-y: overlay !important;
}

.hidescroll::-webkit-scrollbar {
  display: none !important;
}

.posr {
  position: relative !important;
}

.posa {
  position: absolute !important;
}

.posf {
  position: fixed !important;
}

.post0 {
  top: 0 !important;
}

.post10 {
  top: 10 !important;
}

.posr0 {
  right: 0 !important;
}

.posb0 {
  bottom: 0 !important;
}

.posl0 {
  left: 0 !important;
}

.post30 {
  top: 30px !important;
}

.posl40 {
  left: 40px !important;
}

.posr200 {
  right: 200px !important;
}

.postn17 {
  top: -17px !important;
}

.post20n {
  top: -50px !important;
}

.post46 {
  top: 46px !important;
}

.post70 {
  top: 70px !important;
}

.post90 {
  top: 90px !important;
}

.dn {
  display: none !important;
}

.zi0 {
  z-index: 0 !important;
}

.zi1 {
  z-index: 1 !important;
}

.zi2 {
  z-index: 2 !important;
}

.zi3 {
  z-index: 3 !important;
}

.zi100 {
  z-index: 100 !important;
}

.zi500 {
  z-index: 500 !important;
}

.zi1000 {
  z-index: 1000 !important;
}

.zi2500 {
  z-index: 2500 !important;
}

.zi9999 {
  z-index: 9999 !important;
}

.cp {
  color: #0d703f !important;
}

.cw {
  color: white !important;
}

.cs {
  color: #ffdd00 !important;
}

.cdg {
  color: #0b4323 !important;
}

.cpd {
  color: #0b4323 !important;
}

.cr {
  color: #e81d2c !important;
}

.cg1 {
  color: #b4b4b4 !important;
}

.cg2 {
  color: rgb(234, 234, 234) !important;
}

.cg3 {
  color: #424242 !important;
}

.cg4 {
  color: rgba(0, 0, 0, 0.5411764706) !important;
}

.cy {
  color: #fddb00 !important;
}

.cb {
  color: black !important;
}

.cpo {
  color: #61b2b5;
}

.bcp {
  background-color: #0d703f !important;
}

.bcpl {
  background-color: #098442 !important;
}

.bcpd {
  background-color: #0b4323 !important;
}

.bcw {
  background-color: white !important;
}

.bcr {
  background-color: #e81d2c !important;
}

.bco {
  background-color: #FF7F00 !important;
}

.bcy {
  background-color: #fddb00 !important;
}

.bclg {
  background-color: #d9ead3 !important;
}

.bcb {
  background-color: #1b4586 !important;
}

.bcblack {
  background-color: #000 !important;
}

.bcDarkBlue {
  background-color: #052E5C !important;
}

.tcDarkBlue {
  color: #052E5C !important;
}

.tcGreen {
  color: #168944 !important;
}

.bcGreen {
  background-color: #168944 !important;
}

.bcDarkRed {
  background-color: darkred !important;
}

.bcLightBlue {
  background-color: #2294FC !important;
}

.bcGrey {
  background-color: #F0F5F7 !important;
}

.tcOrange {
  color: #f79d33 !important;
}

.bcg0 {
  background-color: #eaeaea !important;
}

.bcg1 {
  background-color: #b4b4b4 !important;
}

.bcg2 {
  background-color: rgb(234, 234, 234) !important;
}

.bcg3 {
  background-color: #424242 !important;
}

.bct {
  background-color: transparent !important;
}

.bclb {
  background-color: #61B2B5 !important;
}

.bcdlg0 {
  background-color: #138544 !important;
}

.bcdlg1 {
  background-color: #a5d380 !important;
}

.bcdlg2 {
  background-color: #89c35a !important;
}

.bcdlg3 {
  background-color: #69af32 !important;
}

.dbcb {
  background-color: #128186 !important;
}

.dbcdb {
  background-color: #272163 !important;
}

.dbclb {
  background-color: #5eb2b6 !important;
}

.dbco {
  background-color: #fd9926 !important;
}

.dbclg {
  background-color: #90c663 !important;
}

.dbcsdg {
  background-color: #138544 !important;
}

.dvblb {
  background-color: #50adb1 !important;
}

.dvbb {
  background-color: #08767b !important;
}

.dvbdb {
  background-color: #272163 !important;
}

.dvblg {
  background-color: #8fcb5c !important;
}

.dvbg {
  background-color: #579523 !important;
}

.dvbdg {
  background-color: #124b0f !important;
}

.dco {
  color: #fd9926 !important;
}

.dcgrey {
  color: #757575 !important;
}

.fw300 {
  font-weight: 300 !important;
}

.fwr {
  font-weight: 400 !important;
}

.fw400 {
  font-weight: 400 !important;
}

.fwm {
  font-weight: 500 !important;
}

.fw500 {
  font-weight: 500 !important;
}

.fw600 {
  font-weight: 600 !important;
}

.fwb {
  font-weight: 700 !important;
}

.fw700 {
  font-weight: 700 !important;
}

.usn {
  user-select: none;
}

.fs8 {
  font-size: 8px !important;
}

.fs10 {
  font-size: 10px !important;
}

.fs11 {
  font-size: 11px !important;
}

.fs12 {
  font-size: 12px !important;
}

.fs13 {
  font-size: 13px !important;
}

.fs14 {
  font-size: 14px !important;
}

.fs15 {
  font-size: 15px !important;
}

.fs16 {
  font-size: 16px !important;
}

.fs18 {
  font-size: 18px !important;
}

.fs19 {
  font-size: 19px !important;
}

.fs20 {
  font-size: 20px !important;
}

.fs23 {
  font-size: 23px !important;
}

.fs25 {
  font-size: 25px !important;
}

.fs28 {
  font-size: 28px !important;
}

.fs30 {
  font-size: 30px !important;
}

.fs32 {
  font-size: 32px !important;
}

.fs36 {
  font-size: 36px !important;
}

.fs40 {
  font-size: 40px !important;
}

.fs41 {
  font-size: 41px !important;
}

.fs45 {
  font-size: 45px !important;
}

.fs46 {
  font-size: 46px !important;
}

.fs50 {
  font-size: 50px !important;
}

.ftu {
  text-transform: uppercase;
}

.lh40 {
  line-height: 40px;
}

.lh37 {
  line-height: 37px;
}

.ls065 {
  letter-spacing: 0.65px;
}

.ls09 {
  letter-spacing: 0.9px;
}

.curp {
  cursor: pointer;
}

/* Random */
.materialCell {
  float: left;
}

.TextField {
  min-height: 48px !important;
  float: left;
  width: 100%;
}

.DropDown {
  float: left;
  width: 100%;
}

.detailsEditing {
  background-color: darkcyan !important;
  color: white !important;
}

.DisplayFieldToRight {
  padding-top: 4px !important;
  padding-bottom: 3px !important;
}

.DisplayFieldBottom {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.DisplayFieldBottomWithSupText {
  margin-top: -1px !important;
  padding-bottom: 3px !important;
}

.DropDownDisplayFieldBottom {
  padding-bottom: 20px !important;
  padding-top: 4px !important;
}

.TransformerMeterNumberReadingsTextField {
  height: 32px !important;
  max-width: 112px !important;
}

.TransformerMeterNumberReadingsDisplayField {
  font-size: 1rem !important;
  padding-top: 4px !important;
}

.GridDetailsDropDown {
  width: calc(100vw - 80px) !important;
}

.Dropzone {
  width: 196px;
  height: 146px;
  position: relative;
  border-width: 2px;
  border-color: rgb(102, 102, 102);
  border-style: dashed;
  border-radius: 5px;
}

.ThumbSize {
  max-width: 200px;
  height: 150px;
}

.ImagePreview {
  max-width: 100%;
  max-height: 100%;
}

.ImageArea {
  max-height: 200px;
  height: 200px;
  justify-content: center;
  text-align: center;
  flex-direction: row;
}

.TitleSelect {
  font-size: 1.3125rem !important;
  font-weight: 500 !important;
  margin-top: -6px !important;
  margin-bottom: -7px !important;
}

.TitleSelect::before {
  border-bottom-width: 0px !important;
  border-bottom-color: white !important;
}

.TitleSelect::after {
  border-bottom-width: 0px !important;
  border-bottom-color: white !important;
}

.PromptButton {
  background-color: white !important;
  color: black !important;
  min-width: 86px !important;
}

.PromptButton:hover {
  opacity: 0.6 !important;
}

.PromptButton:focus {
  background-color: #168944 !important;
  color: white !important;
}

.PromptButton[type=submit] {
  background-color: #168944 !important;
  color: white !important;
}

.VerticalText {
  writing-mode: tb !important;
  -webkit-transform: rotate(180deg) !important;
  -moz-transform: rotate(180deg) !important;
  -ms-transform: rotate(180deg) !important;
  -o-transform: rotate(180deg) !important;
  transform: rotate(180deg) !important;
}

.RoundedCorners {
  border-radius: 10px;
}

.NewDesignDisplayField {
  font-size: 1rem !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  line-height: 1.1875em !important;
  padding-top: 6px !important;
  padding-bottom: 7px !important;
}

.NewDesignDisplayFieldWithSup {
  font-size: 1rem !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  line-height: 1.1875em !important;
  padding-top: 1px !important;
  padding-bottom: 12px !important;
}

div.CalibrationTestTable::-webkit-scrollbar {
  height: 10px;
}

div.CalibrationTestTable::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  padding-right: 5px;
}

div.CalibrationTestTable::-webkit-scrollbar-thumb {
  background: #1e4776;
  border-radius: 10px;
}

div.CalibrationTestTable::-webkit-scrollbar-thumb:hover {
  background: #052e5c;
}

/** SCROLL **/
.drawer::-webkit-scrollbar {
  width: 5px;
  border-radius: 5px;
}

.drawer::-webkit-scrollbar-track {
  background: #eaeaea;
}

/* Handle */
.drawer::-webkit-scrollbar-thumb {
  background: #0d703f;
}

/* Handle on hover */
.drawer::-webkit-scrollbar-thumb:hover {
  background: #0b4323;
}

/**toggleStadiumButton**/
/* Handles the background of the toggleStadiumButton */
.toggleStadiumButtonSelected {
  background-color: #0d703f !important;
  color: white !important;
}

.toggleStadiumButtonUnselected {
  background-color: #fd0 !important;
  color: #0d703f !important;
}

.toggleStadiumButtonIconSelected {
  background-color: #0d703f !important;
}

.toggleStadiumButtonIconUnselected {
  background-color: #fd0 !important;
}

/* Handles the background of the toggleStadiumButton on hover */
.toggleStadiumButtonSelected:hover {
  background-color: #0b4323 !important;
}

.toggleStadiumButtonUnselected:hover {
  background-color: #dbbe00 !important;
}

.mximg img {
  max-height: 130px !important;
}

.dam-summary-Heading {
  font-size: 12px !important;
  color: rgb(102, 102, 102);
  display: flex;
  flex: 1;
}

.dam-summary-detail {
  font-size: 14px !important;
  display: flex;
  flex: 1;
  font-weight: 700;
}

.rotate {
  writing-mode: vertical-rl;
  text-orientation: sideways-left;
}

.file-card-backdrop::before {
  content: "";
  background-size: cover;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background: #000000 0% 0% no-repeat padding-box;
  opacity: 0.61;
}

div.hidden {
  visibility: hidden;
}

div.hidden:hover {
  visibility: visible;
}

.fab.save {
  background-color: #fd0;
  color: #004b22;
  min-width: 100px !important;
}

.fab.save:hover {
  background-color: #fd3;
}

.fab.save > span:nth-child(1) {
  padding: 0px 15px;
}

.fab.cancel {
  background-color: transparent;
  color: #004b22;
  box-shadow: none;
  min-width: 100px !important;
}

.rdrDay {
  color: #168944 !important;
}

.rdrStartEdge {
  color: #168944 !important;
}

.rdrEndEdge {
  color: #168944 !important;
}

.rdrInRange {
  color: #168944 !important;
}

.rdrStaticRangeLabel {
  color: #168944 !important;
}

.rdrDateDisplay {
  color: #168944 !important;
}

.rdrDayToday {
  color: #168944 !important;
}

.rdrDayToday .rdrDayNumber span:after {
  background: #168944 !important;
}

.rdrDayToday .rdrInRange ~ .rdrDayNumber span:after, .rdrDayToday .rdrStartEdge ~ .rdrDayNumber span:after, .rdrDayToday .rdrEndEdge ~ .rdrDayNumber span:after, .rdrDayToday .rdrSelected ~ .rdrDayNumber span:after {
  background: #fff !important;
}

.rdrDayStartPreview {
  color: #168944 !important;
}

.rdrDayEndPreview {
  color: #168944 !important;
}

.rdrDayInPreview {
  color: #168944 !important;
}

.rdrSelected {
  color: #168944 !important;
}

/* Breadcrumbs */
.breadcrumbLink {
  color: inherit !important;
  text-decoration: none !important;
}

.breadcrumbLink:hover {
  color: inherit !important;
  text-decoration: underline !important;
}

/* side menu item component */
.sideMenuButton:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* nav drawer */
.disableImageDrag {
  -webkit-user-drag: none;
}

.filterShadow {
  box-shadow: 0px 3px 6px #424242 !important;
}

/* scrolling */
div.scroll-area::-webkit-scrollbar {
  height: 7px;
}

div.scroll-area::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
  border-radius: 10px;
}

div.scroll-area::-webkit-scrollbar-thumb {
  background: #0d703f;
  border-radius: 10px;
}

div.scroll-area::-webkit-scrollbar-thumb:hover {
  background: #1b6337;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  scrollbar-width: thin;
}

::-webkit-scrollbar-track {
  background: white;
}

::-webkit-scrollbar-thumb {
  background: #bbbbbb;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #979797;
}

/* login */
.blur {
  backdrop-filter: blur(15px);
}

.login-card-background {
  background: rgba(0, 0, 0, 0.3) !important;
}

/* Change default input underline to primary green */
.MuiInput-underline:before {
  border-bottom-color: #0d703f !important;
}

/* Font Style */
.fsi {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/style/customTableStyles.scss","webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;ACCJ;;ADEA;EACI,2BAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ;;ADEA;EACI,yBAAA;ACCJ;;ADEA;EACI,yBAAA;ACCJ;;ADEA;EACI,6BAAA;EACA,oBAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ;;ADEA;EACI,wCAAA;ACCJ;;ADEA;EACI,cChCkB;AAiCtB;;ADEA;EACI,oCAAA;ACCJ;;ADEA,4CAAA;AACA;EACI,8BAAA;ACCJ;;AALA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAQJ;;AALA;EAAgC,oBAAA;AAShC;;AAPA;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;AAUJ;;AAPA,YAAA;AAEA;EAAQ,wBAAA;EAA0B,kBAAA;AAWlC;;AAVA;EAAQ,wBAAA;EAA0B,kBAAA;AAelC;;AAdA;EAAQ,wBAAA;EAA0B,kBAAA;AAmBlC;;AAlBA;EAAQ,wBAAA;EAA0B,kBAAA;AAuBlC;;AAtBA;EAAQ,wBAAA;EAA0B,kBAAA;AA2BlC;;AAzBA;EACI,wBAAA;EACA,8BAAA;EACA,uBAAA;AA4BJ;;AA1BA;EACI,wBAAA;EACA,iCAAA;EACA,wBAAA;AA6BJ;;AA1BA;EACI,wBAAA;EACA,sCAAA;AA6BJ;;AA3BA;EACI,wBAAA;EACA,yCAAA;AA8BJ;;AA3BA;EAAO,wBAAA;EAA0B,0BAAA;AAgCjC;;AA9BA;EACI,wBAAA;EACA,kCAAA;AAiCJ;;AA/BA;EACI,wBAAA;EACA,8BAAA;AAkCJ;;AAhCA;EACI,wBAAA;EACA,gCAAA;AAmCJ;;AAjCA;EACI,wBAAA;EACA,+BAAA;AAoCJ;;AAjCA;EACI,wBAAA;EACA,sCAAA;AAoCJ;;AAlCA;EACI,wBAAA;EACA,kCAAA;AAqCJ;;AAnCA;EACI,wBAAA;EACA,iCAAA;AAsCJ;;AApCA;EACI,wBAAA;EACA,oCAAA;AAuCJ;;AArCA;EACI,wBAAA;EACA,wCAAA;AAwCJ;;AAtCA;EACI,wBAAA;EACA,yCAAA;AAyCJ;;AAvCA;EACI,wBAAA;EACA,wCAAA;AA0CJ;;AAvCA;EACI,wBAAA;EACA,6BAAA;AA0CJ;;AAvCA;EACI,8BAAA;AA0CJ;;AAvCA;EACI,6BAAA;AA0CJ;;AAvCA;EAAiB,0BAAA;AA2CjB;;AAzCA;EAAO,iCAAA;AA6CP;;AA3CA;EACI,aAAA;EACA,gCAAA;AA8CJ;;AA3CA;EACI,aAAA;EACA,qCAAA;AA8CJ;;AA3CA;EACI,aAAA;EACA,0CAAA;AA8CJ;;AA3CA,YAAA;AAEA;EAAM,uBAAA;AA8CN;;AA7CA;EAAM,4BAAA;AAiDN;;AAhDA;EAAO,uBAAA;EAAyB,8BAAA;AAqDhC;;AApDA;EAAO,uBAAA;EAAyB,8BAAA;AAyDhC;;AAxDA;EAAQ,wBAAA;AA4DR;;AA1DA;EAAQ,qBA1Ka;AAwOrB;;AA7DA;EAAS,qBAhLM;AAiPf;;AAhEA;EAAS,qBA9KM;AAkPf;;AAnEA;EAAO,8BAAA;AAuEP;;AAtEA;EAAc,gCAAA;AA0Ed;;AAzEA;EAAU,gCAAA;AA6EV;;AA5EA;EAAW,8BAAA;AAgFX;;AA9EA;EAAM,6BAAA;AAkFN;;AAjFA;EAAM,6BAAA;AAqFN;;AApFA;EAAM,6BAAA;AAwFN;;AAvFA;EAAM,6BAAA;AA2FN;;AA1FA;EAAO,8BAAA;AA8FP;;AA7FA;EAAO,8BAAA;AAiGP;;AAhGA;EAAO,8BAAA;AAoGP;;AAnGA;EAAO,8BAAA;AAuGP;;AAtGA;EAAO,8BAAA;AA0GP;;AAzGA;EAAO,8BAAA;AA6GP;;AA5GA;EAAO,8BAAA;AAgHP;;AA/GA;EAAO,8BAAA;AAmHP;;AAjHA;EAAO,8BAAA;AAqHP;;AAnHA,eAAA;AACA;EAAQ,sBAAA;AAuHR;;AAtHA;EAAmB,oCAAA;AA0HnB;;AAzHA;EAAK,mBAAA;AA6HL;;AA5HA;EAAK,qBAAA;AAgIL;;AA/HA;EAAK,qBAAA;AAmIL;;AAlIA;EAAK,qBAAA;AAsIL;;AArIA;EAAK,qBAAA;AAyIL;;AAxIA;EAAM,sBAAA;AA4IN;;AA3IA;EAAM,sBAAA;AA+IN;;AA9IA;EAAM,sBAAA;AAkJN;;AAjJA;EAAM,sBAAA;AAqJN;;AApJA;EAAM,sBAAA;AAwJN;;AAvJA;EAAM,sBAAA;AA2JN;;AA1JA;EAAM,sBAAA;EAAwB,0BAAA;AA+J9B;;AA9JA;EAAM,sBAAA;EAAwB,0BAAA;AAmK9B;;AAlKA;EAAM,sBAAA;AAsKN;;AArKA;EAAM,sBAAA;EAAwB,0BAAA;AA0K9B;;AAzKA;EAAM,sBAAA;EAAwB,0BAAA;AA8K9B;;AA7KA;EAAM,sBAAA;EAAwB,0BAAA;AAkL9B;;AAjLA;EAAM,sBAAA;EAAwB,0BAAA;AAsL9B;;AArLA;EAAO,uBAAA;AAyLP;;AAxLA;EAAO,uBAAA;AA4LP;;AA3LA;EAAO,uBAAA;AA+LP;;AA9LA;EAAO,uBAAA;AAkMP;;AAjMA;EAAO,uBAAA;AAqMP;;AApMA;EAAS,2BAAA;AAwMT;;AAvMA;EAAO,uBAAA;AA2MP;;AA1MA;EAAO,uBAAA;AA8MP;;AA7MA;EAAO,uBAAA;AAiNP;;AAhNA;EAAO,uBAAA;AAoNP;;AAnNA;EAAO,uBAAA;AAuNP;;AAtNA;EAAO,uBAAA;AA0NP;;AAzNA;EAAO,uBAAA;AA6NP;;AA5NA;EAAO,uBAAA;AAgOP;;AA/NA;EAAO,uBAAA;AAmOP;;AAlOA;EAAO,uBAAA;AAsOP;;AArOA;EAAO,uBAAA;AAyOP;;AAxOA;EAAO,uBAAA;AA4OP;;AA3OA;EAAO,uBAAA;AA+OP;;AA9OA;EAAO,uBAAA;AAkPP;;AAjPA;EAAO,uBAAA;AAqPP;;AApPA;EAAO,uBAAA;AAwPP;;AAvPA;EAAQ,wBAAA;AA2PR;;AA1PA;EAAQ,wBAAA;AA8PR;;AA7PA;EAAQ,wBAAA;AAiQR;;AA/PA;EAAM,0BAAA;AAmQN;;AAlQA;EAAO,0BAAA;AAsQP;;AArQA;EAAQ,2BAAA;AAyQR;;AAxQA;EAAQ,2BAAA;AA4QR;;AA3QA;EAAQ,2BAAA;AA+QR;;AA9QA;EAAQ,2BAAA;AAkRR;;AAjRA;EAAQ,2BAAA;AAqRR;;AApRA;EAAQ,2BAAA;AAwRR;;AAvRA;EAAQ,2BAAA;AA2RR;;AAzRA;EAAQ,uBAAA;AA6RR;;AA5RA;EAAQ,uBAAA;AAgSR;;AA/RA;EAAK,oBAAA;AAmSL;;AAlSA;EAAM,wBAAA;AAsSN;;AArSA;EAAM,sBAAA;AAySN;;AAxSA;EAAM,sBAAA;AA4SN;;AA3SA;EAAO,0BAAA;AA+SP;;AA9SA;EAAM,sBAAA;AAkTN;;AAjTA;EAAM,uBAAA;AAqTN;;AApTA;EAAM,uBAAA;AAwTN;;AAvTA;EAAM,uBAAA;AA2TN;;AA1TA;EAAQ,2BAAA;AA8TR;;AA7TA;EAAQ,2BAAA;AAiUR;;AAhUA;EAAM,uBAAA;AAoUN;;AAnUA;EAAM,uBAAA;AAuUN;;AAtUA;EAAM,uBAAA;AA0UN;;AAzUA;EAAQ,2BAAA;AA6UR;;AA5UA;EAAM,uBAAA;AAgVN;;AA/UA;EAAM,uBAAA;AAmVN;;AAlVA;EAAM,uBAAA;AAsVN;;AArVA;EAAM,uBAAA;AAyVN;;AAxVA;EAAM,uBAAA;AA4VN;;AA3VA;EAAQ,2BAAA;AA+VR;;AA9VA;EAAM,uBAAA;AAkWN;;AAjWA;EAAM,uBAAA;EAAyB,2BAAA;AAsW/B;;AArWA;EAAQ,2BAAA;AAyWR;;AAxWA;EAAQ,2BAAA;AA4WR;;AA3WA;EAAM,uBAAA;AA+WN;;AA9WA;EAAQ,2BAAA;AAkXR;;AAjXA;EAAM,uBAAA;AAqXN;;AApXA;EAAS,4BAAA;AAwXT;;AAvXA;EAAO,wBAAA;AA2XP;;AA1XA;EAAQ,4BAAA;AA8XR;;AA7XA;EAAO,wBAAA;AAiYP;;AAhYA;EAAS,4BAAA;AAoYT;;AAnYA;EAAO,wBAAA;AAuYP;;AAtYA;EAAO,wBAAA;AA0YP;;AAzYA;EAAO,wBAAA;AA6YP;;AA5YA;EAAQ,4BAAA;AAgZR;;AA/YA;EAAO,wBAAA;AAmZP;;AAlZA;EAAS,4BAAA;AAsZT;;AArZA;EAAS,4BAAA;AAyZT;;AAxZA;EAAO,wBAAA;AA4ZP;;AA3ZA;EAAS,4BAAA;AA+ZT;;AA9ZA;EAAO,wBAAA;AAkaP;;AAjaA;EAAO,wBAAA;AAqaP;;AApaA;EAAO,wBAAA;AAwaP;;AAvaA;EAAO,wBAAA;AA2aP;;AA1aA;EAAS,4BAAA;AA8aT;;AA7aA;EAAS,4BAAA;AAibT;;AAhbA;EAAO,wBAAA;AAobP;;AAnbA;EAAS,4BAAA;AAubT;;AAtbA;EAAO,8BAAA;AA0bP;;AAzbA;EAAO,wBAAA;AA6bP;;AA5bA;EAAS,4BAAA;AAgcT;;AA/bA;EAAS,cAAA;AAmcT;;AAjcA;EAAK,sBAAA;AAqcL;;AApcA;EAAM,uBAAA;AAwcN;;AAvcA;EAAM,uBAAA;AA2cN;;AA1cA;EAAM,uBAAA;AA8cN;;AA5cA;EAAM,2BAAA;AAgdN;;AA/cA;EAAM,2BAAA;AAmdN;;AAldA;EAAO,4BAAA;AAsdP;;AArdA;EAAO,4BAAA;AAydP;;AAxdA;EAAO,4BAAA;AA4dP;;AA3dA;EAAO,4BAAA;AA+dP;;AA9dA;EAAO,4BAAA;AAkeP;;AAjeA;EAAO,4BAAA;AAqeP;;AApeA;EAAO,4BAAA;AAweP;;AAveA;EAAO,4BAAA;AA2eP;;AA1eA;EAAO,4BAAA;AA8eP;;AA7eA;EAAQ,6BAAA;AAifR;;AA/eA;EAAM,4BAAA;AAmfN;;AAlfA;EAAM,4BAAA;AAsfN;;AArfA;EAAM,4BAAA;AAyfN;;AAxfA;EAAM,4BAAA;AA4fN;;AA3fA;EAAO,6BAAA;AA+fP;;AA9fA;EAAO,6BAAA;AAkgBP;;AAjgBA;EAAO,6BAAA;AAqgBP;;AApgBA;EAAO,6BAAA;AAwgBP;;AAvgBA;EAAO,6BAAA;AA2gBP;;AA1gBA;EAAO,6BAAA;AA8gBP;;AA7gBA;EAAO,6BAAA;AAihBP;;AAhhBA;EAAO,6BAAA;AAohBP;;AAnhBA;EAAO,6BAAA;AAuhBP;;AAthBA;EAAO,6BAAA;AA0hBP;;AAzhBA;EAAQ,8BAAA;AA6hBR;;AA3hBA;EAA2B,6BAAA;AA+hB3B;;AA7hBA;EAAM,0BAAA;AAiiBN;;AAhiBA;EAAM,0BAAA;AAoiBN;;AAniBA;EAAM,0BAAA;AAuiBN;;AAtiBA;EAAO,2BAAA;AA0iBP;;AAziBA;EAAO,2BAAA;AA6iBP;;AA5iBA;EAAO,2BAAA;AAgjBP;;AA/iBA;EAAO,2BAAA;AAmjBP;;AAljBA;EAAO,2BAAA;AAsjBP;;AArjBA;EAAO,2BAAA;AAyjBP;;AAxjBA;EAAO,2BAAA;AA4jBP;;AA3jBA;EAAO,2BAAA;AA+jBP;;AA9jBA;EAAO,2BAAA;AAkkBP;;AAjkBA;EAAO,2BAAA;AAqkBP;;AApkBA;EAAO,2BAAA;AAwkBP;;AAvkBA;EAAO,2BAAA;AA2kBP;;AA1kBA;EAAQ,4BAAA;AA8kBR;;AA5kBA;EAAQ,+BAAA;AAglBR;;AA/kBA;EAAM,6BAAA;AAmlBN;;AAllBA;EAAM,6BAAA;AAslBN;;AArlBA;EAAM,6BAAA;AAylBN;;AAxlBA;EAAM,6BAAA;AA4lBN;;AA3lBA;EAAO,8BAAA;AA+lBP;;AA9lBA;EAAO,8BAAA;AAkmBP;;AAjmBA;EAAO,8BAAA;AAqmBP;;AApmBA;EAAO,8BAAA;AAwmBP;;AAvmBA;EAAO,8BAAA;AA2mBP;;AA1mBA;EAAO,8BAAA;AA8mBP;;AA7mBA;EAAO,8BAAA;AAinBP;;AAhnBA;EAAO,8BAAA;AAonBP;;AAnnBA;EAAO,8BAAA;AAunBP;;AAtnBA;EAAO,8BAAA;AA0nBP;;AAznBA;EAAQ,+BAAA;AA6nBR;;AA5nBA;EAAQ,+BAAA;AAgoBR;;AA9nBA;EAAK,qBAAA;AAkoBL;;AAjoBA;EAAK,uBAAA;AAqoBL;;AApoBA;EAAK,uBAAA;AAwoBL;;AAvoBA;EAAM,wBAAA;AA2oBN;;AA1oBA;EAAM,wBAAA;AA8oBN;;AA7oBA;EAAM,wBAAA;AAipBN;;AAhpBA;EAAM,wBAAA;AAopBN;;AAnpBA;EAAM,wBAAA;AAupBN;;AAtpBA;EAAM,wBAAA;AA0pBN;;AAzpBA;EAAM,wBAAA;AA6pBN;;AA3pBA;EAAM,2BAAA;AA+pBN;;AA9pBA;EAAM,6BAAA;AAkqBN;;AAjqBA;EAAO,8BAAA;AAqqBP;;AApqBA;EAAO,8BAAA;AAwqBP;;AAvqBA;EAAO,8BAAA;AA2qBP;;AA1qBA;EAAO,8BAAA;AA8qBP;;AA7qBA;EAAO,8BAAA;AAirBP;;AAhrBA;EAAO,8BAAA;AAorBP;;AAnrBA;EAAO,8BAAA;AAurBP;;AAtrBA;EAAO,8BAAA;AA0rBP;;AAzrBA;EAAO,8BAAA;AA6rBP;;AA5rBA;EAAQ,+BAAA;AAgsBR;;AA9rBA;EAAM,4BAAA;AAksBN;;AAjsBA;EAAM,4BAAA;AAqsBN;;AApsBA;EAAM,4BAAA;AAwsBN;;AAvsBA;EAAM,4BAAA;AA2sBN;;AA1sBA;EAAO,6BAAA;AA8sBP;;AA7sBA;EAAO,6BAAA;AAitBP;;AAhtBA;EAAO,6BAAA;AAotBP;;AAntBA;EAAO,6BAAA;AAutBP;;AAttBA;EAAO,6BAAA;AA0tBP;;AAztBA;EAAO,6BAAA;AA6tBP;;AA5tBA;EAAO,6BAAA;AAguBP;;AA/tBA;EAAQ,8BAAA;AAmuBR;;AAjuBA;EAAM,2BAAA;AAquBN;;AApuBA;EAAM,2BAAA;AAwuBN;;AAvuBA;EAAM,2BAAA;AA2uBN;;AA1uBA;EAAO,4BAAA;AA8uBP;;AA7uBA;EAAO,4BAAA;AAivBP;;AAhvBA;EAAO,4BAAA;AAovBP;;AAnvBA;EAAO,4BAAA;AAuvBP;;AAtvBA;EAAO,4BAAA;AA0vBP;;AAzvBA;EAAO,4BAAA;AA6vBP;;AA5vBA;EAAO,4BAAA;AAgwBP;;AA9vBA;EAAM,8BAAA;AAkwBN;;AAjwBA;EAAM,8BAAA;AAqwBN;;AApwBA;EAAM,8BAAA;AAwwBN;;AAvwBA;EAAM,8BAAA;AA2wBN;;AA1wBA;EAAM,8BAAA;AA8wBN;;AA7wBA;EAAM,8BAAA;AAixBN;;AAhxBA;EAAO,+BAAA;AAoxBP;;AAnxBA;EAAO,+BAAA;AAuxBP;;AAtxBA;EAAO,+BAAA;AA0xBP;;AAzxBA;EAAO,+BAAA;AA6xBP;;AA5xBA;EAAO,+BAAA;AAgyBP;;AA/xBA;EAAO,+BAAA;AAmyBP;;AAlyBA;EAAO,+BAAA;AAsyBP;;AAryBA;EAAO,+BAAA;AAyyBP;;AAvyBA;EAAK,2BAAA;AA2yBL;;AA1yBA;EAAM,6BAAA;AA8yBN;;AA7yBA;EAAM,6BAAA;AAizBN;;AAhzBA;EAAM,2BAAA;AAozBN;;AAnzBA;EAAM,6BAAA;AAuzBN;;AAtzBA;EAAM,6BAAA;AA0zBN;;AAzzBA;EAAK,4BAAA;AA6zBL;;AA5zBA;EAAK,yBAAA;AAg0BL;;AA/zBA;EAAM,8BAAA;AAm0BN;;AAj0BA;EAAiC,wBAAA;AAq0BjC;;AAn0BA;EAAO,6BAAA;AAu0BP;;AAt0BA;EAAO,6BAAA;AA00BP;;AAz0BA;EAAO,0BAAA;AA60BP;;AA30BA;EAAQ,iBAAA;AA+0BR;;AA90BA;EAAS,kBAAA;AAk1BT;;AAj1BA;EAAQ,mBAAA;AAq1BR;;AAp1BA;EAAQ,oBAAA;AAw1BR;;AAv1BA;EAAQ,kBAAA;AA21BR;;AA11BA;EAAS,oBAAA;AA81BT;;AA71BA;EAAS,qBAAA;AAi2BT;;AA/1BA;EAAU,uBAAA;AAm2BV;;AAj2BA;EAAU,qBAAA;AAq2BV;;AAp2BA;EAAU,qBAAA;AAw2BV;;AAv2BA;EAAS,oBAAA;AA22BT;;AA12BA;EAAS,oBAAA;AA82BT;;AA72BA;EAAS,oBAAA;AAi3BT;;AA/2BA;EAAK,wBAAA;AAm3BL;;AAj3BA;EAAM,qBAAA;AAq3BN;;AAp3BA;EAAM,qBAAA;AAw3BN;;AAv3BA;EAAM,qBAAA;AA23BN;;AA13BA;EAAM,qBAAA;AA83BN;;AA73BA;EAAQ,uBAAA;AAi4BR;;AAh4BA;EAAQ,uBAAA;AAo4BR;;AAn4BA;EAAS,wBAAA;AAu4BT;;AAt4BA;EAAS,wBAAA;AA04BT;;AAz4BA;EAAS,wBAAA;AA64BT;;AA34BA;EAAK,yBAAA;AA+4BL;;AA94BA;EAAK,uBAAA;AAk5BL;;AAj5BA;EAAK,yBAAA;AAq5BL;;AAp5BA;EAAM,yBAAA;AAw5BN;;AAv5BA;EAAM,yBAAA;AA25BN;;AA15BA;EAAK,yBAAA;AA85BL;;AA75BA;EAAM,yBAAA;AAi6BN;;AAh6BA;EAAM,oCAAA;AAo6BN;;AAn6BA;EAAM,yBAAA;AAu6BN;;AAt6BA;EAAM,6CAAA;AA06BN;;AAz6BA;EAAK,yBAAA;AA66BL;;AA56BA;EAAK,uBAAA;AAg7BL;;AA/6BA;EAAM,cAjdO;AAo4Cb;;AAj7BA;EAAM,oCAAA;AAq7BN;;AAp7BA;EAAO,oCAAA;AAw7BP;;AAv7BA;EAAO,oCAAA;AA27BP;;AA17BA;EAAM,kCAAA;AA87BN;;AA77BA;EAAM,oCAAA;AAi8BN;;AAh8BA;EAAM,oCAAA;AAo8BN;;AAn8BA;EAAM,oCAAA;AAu8BN;;AAt8BA;EAAO,oCAAA;AA08BP;;AAz8BA;EAAM,oCAAA;AA68BN;;AA58BA;EAAU,iCAAA;AAg9BV;;AA/8BA;EAAa,oCAAA;AAm9Bb;;AAl9BA;EAAa,yBAAA;AAs9Bb;;AAr9BA;EAAU,yBAAA;AAy9BV;;AAx9BA;EAAU,oCAAA;AA49BV;;AA39BA;EAAY,oCAAA;AA+9BZ;;AA99BA;EAAc,oCAAA;AAk+Bd;;AAj+BA;EAAS,oCAAA;AAq+BT;;AAp+BA;EAAW,yBAAA;AAw+BX;;AAv+BA;EAAO,oCAAA;AA2+BP;;AA1+BA;EAAO,oCAAA;AA8+BP;;AA7+BA;EAAO,+CAAA;AAi/BP;;AAh/BA;EAAO,oCAAA;AAo/BP;;AAn/BA;EAAM,wCAAA;AAu/BN;;AAt/BA;EAAO,oCAAA;AA0/BP;;AAx/BA;EAAQ,oCAAA;AA4/BR;;AA3/BA;EAAQ,oCAAA;AA+/BR;;AA9/BA;EAAQ,oCAAA;AAkgCR;;AAjgCA;EAAQ,oCAAA;AAqgCR;;AAngCA;EAAO,oCAAA;AAugCP;;AAtgCA;EAAQ,oCAAA;AA0gCR;;AAzgCA;EAAQ,oCAAA;AA6gCR;;AA5gCA;EAAO,oCAAA;AAghCP;;AA/gCA;EAAQ,oCAAA;AAmhCR;;AAlhCA;EAAS,oCAAA;AAshCT;;AAphCA;EAAO,oCAAA;AAwhCP;;AAvhCA;EAAM,oCAAA;AA2hCN;;AA1hCA;EAAO,oCAAA;AA8hCP;;AA7hCA;EAAO,oCAAA;AAiiCP;;AAhiCA;EAAM,oCAAA;AAoiCN;;AAniCA;EAAO,oCAAA;AAuiCP;;AAriCA;EAAM,yBAAA;AAyiCN;;AAviCA;EAAQ,yBAAA;AA2iCR;;AAziCA;EAAO,2BAAA;AA6iCP;;AA5iCA;EAAM,2BAAA;AAgjCN;;AA/iCA;EAAQ,2BAAA;AAmjCR;;AAljCA;EAAM,2BAAA;AAsjCN;;AArjCA;EAAQ,2BAAA;AAyjCR;;AAxjCA;EAAQ,2BAAA;AA4jCR;;AA3jCA;EAAM,2BAAA;AA+jCN;;AA9jCA;EAAQ,2BAAA;AAkkCR;;AAhkCA;EAAO,iBAAA;AAokCP;;AAlkCA;EAAM,yBAAA;AAskCN;;AArkCA;EAAO,0BAAA;AAykCP;;AAxkCA;EAAO,0BAAA;AA4kCP;;AA3kCA;EAAO,0BAAA;AA+kCP;;AA9kCA;EAAO,0BAAA;AAklCP;;AAjlCA;EAAO,0BAAA;AAqlCP;;AAplCA;EAAO,0BAAA;AAwlCP;;AAvlCA;EAAO,0BAAA;AA2lCP;;AA1lCA;EAAO,0BAAA;AA8lCP;;AA7lCA;EAAO,0BAAA;AAimCP;;AAhmCA;EAAO,0BAAA;AAomCP;;AAnmCA;EAAO,0BAAA;AAumCP;;AAtmCA;EAAO,0BAAA;AA0mCP;;AAzmCA;EAAO,0BAAA;AA6mCP;;AA5mCA;EAAO,0BAAA;AAgnCP;;AA/mCA;EAAO,0BAAA;AAmnCP;;AAlnCA;EAAO,0BAAA;AAsnCP;;AArnCA;EAAO,0BAAA;AAynCP;;AAxnCA;EAAO,0BAAA;AA4nCP;;AA3nCA;EAAO,0BAAA;AA+nCP;;AA9nCA;EAAO,0BAAA;AAkoCP;;AAjoCA;EAAO,0BAAA;AAqoCP;;AAnoCA;EACI,yBAAA;AAsoCJ;;AApoCA;EACI,iBAAA;AAuoCJ;;AApoCA;EACI,iBAAA;AAuoCJ;;AApoCA;EACI,sBAAA;AAuoCJ;;AApoCA;EACI,qBAAA;AAuoCJ;;AApoCA;EACI,eAAA;AAuoCJ;;AApoCA,WAAA;AAEA;EACI,WAAA;AAsoCJ;;AAloCA;EACI,2BAAA;EACA,WAAA;EACA,WAAA;AAqoCJ;;AAloCA;EACI,WAAA;EACA,WAAA;AAqoCJ;;AAloCA;EACI,qCAAA;EACA,uBAAA;AAqoCJ;;AAloCA;EACI,2BAAA;EACA,8BAAA;AAqoCJ;;AAloCA;EACI,2BAAA;EACA,8BAAA;AAqoCJ;;AAloCA;EACI,2BAAA;EACA,8BAAA;AAqoCJ;;AAjoCA;EACI,+BAAA;EACA,2BAAA;AAooCJ;;AAjoCA;EACI,uBAAA;EACA,2BAAA;AAooCJ;;AAjoCA;EACI,0BAAA;EACA,2BAAA;AAooCJ;;AAjoCA;EACI,oCAAA;AAooCJ;;AAjoCA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;AAooCJ;;AAjoCA;EACI,gBAAA;EACA,aAAA;AAooCJ;;AAjoCA;EACI,eAAA;EACA,gBAAA;AAooCJ;;AAjoCA;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAooCJ;;AAjoCA;EACI,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;AAooCJ;;AAjoCA;EACI,mCAAA;EACA,qCAAA;AAooCJ;;AAjoCA;EACI,mCAAA;EACA,qCAAA;AAooCJ;;AAjoCA;EACI,kCAAA;EACA,uBAAA;EACA,0BAAA;AAooCJ;;AAjoCA;EACI,uBAAA;AAooCJ;;AAjoCA;EACI,oCAAA;EACA,uBAAA;AAooCJ;;AAjoCA;EACI,oCAAA;EACA,uBAAA;AAooCJ;;AAjoCA;EACI,2BAAA;EACA,4CAAA;EACA,yCAAA;EACA,wCAAA;EACA,uCAAA;EACA,oCAAA;AAooCJ;;AAjoCA;EACI,mBAAA;AAooCJ;;AAjoCA;EACI,0BAAA;EACA,kEAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AAooCJ;;AAjoCA;EACI,0BAAA;EACA,kEAAA;EACA,gCAAA;EACA,2BAAA;EACA,+BAAA;AAooCJ;;AAjoCA;EACI,YAAA;AAooCJ;;AAjoCA;EACI,8BAAA;EACA,mBAAA;EACA,kBAAA;AAooCJ;;AAjoCA;EACI,mBAAA;EACA,mBAAA;AAooCJ;;AAjoCA;EACI,mBAAA;AAooCJ;;AAhoCA,aAAA;AACA;EACI,UAAA;EACA,kBAAA;AAmoCJ;;AAhoCA;EACI,mBApxBW;AAu5Df;;AAhoCA,WAAA;AACA;EACI,mBApxBiB;AAu5DrB;;AAhoCA,oBAAA;AACA;EACI,mBAxxBiB;AA25DrB;;AAhoCA,wBAAA;AAEA,sDAAA;AACA;EACI,oCAAA;EACA,uBAAA;AAkoCJ;;AAhoCA;EACI,iCAAA;EACA,yBAAA;AAmoCJ;;AAhoCA;EACI,oCAAA;AAmoCJ;;AAjoCA;EACI,iCAAA;AAooCJ;;AAjoCA,+DAAA;AACA;EACI,oCAAA;AAooCJ;;AAjoCA;EACI,oCAAA;AAooCJ;;AAjoCA;EACI,4BAAA;AAooCJ;;AAloCA;EACI,0BAAA;EACA,yBAAA;EACA,aAAA;EACA,OAAA;AAqoCJ;;AAloCA;EACI,0BAAA;EACA,aAAA;EACA,OAAA;EACA,gBAAA;AAqoCJ;;AAloCA;EACI,yBAAA;EACA,+BAAA;AAqoCJ;;AAloCA;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,+CAAA;EACA,aAAA;AAqoCJ;;AAloCA;EACI,kBAAA;AAqoCJ;;AAloCA;EACI,mBAAA;AAqoCJ;;AAnoCA;EACI,sBAAA;EACA,cAAA;EACA,2BAAA;AAsoCJ;;AApoCA;EACI,sBAAA;AAuoCJ;;AAroCA;EACI,iBAAA;AAwoCJ;;AAtoCA;EACI,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,8BAAA;AAyoCJ;;AAtoCA;EACI,2BAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA;EACI,yBAAA;AAyoCJ;;AAtoCA,gBAAA;AAEA;EACI,yBAAA;EACA,gCAAA;AAwoCJ;;AAroCA;EACI,yBAAA;EACA,qCAAA;AAwoCJ;;AAroCA,6BAAA;AAEA;EACI,gDAAA;AAuoCJ;;AApoCA,eAAA;AAEA;EACI,uBAAA;AAsoCJ;;AAnoCA;EAAe,0CAAA;AAuoCf;;AAroCA,cAAA;AAEA;EACI,WAAA;AAuoCJ;;AApoCA;EACI,+BAAA;EACA,mBAAA;AAuoCJ;;AApoCA;EACI,mBA78BiB;EA88BjB,mBAAA;AAuoCJ;;AApoCA;EACI,mBAAA;AAuoCJ;;AA/nCA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAkoCF;;AA/nCA;EACE,iBAx+BY;AA0mEd;;AA/nCA;EACE,mBAdsB;EAetB,kBAAA;AAkoCF;AAhoCE;EACE,mBAjB0B;AAmpC9B;;AA9nCA,UAAA;AAEA;EAAO,2BAAA;AAioCP;;AA/nCA;EAAwB,yCAAA;AAmoCxB;;AAjoCA,oDAAA;AACA;EACE,uCAAA;AAooCF;;AAjoCA,eAAA;AACA;EACI,kBAAA;AAooCJ","sourcesContent":[".MuiDataGrid-columnHeaders .MuiSvgIcon-root {\n    color: $COLOR_WHITE !important;\n}\n\n.MuiDataGrid-footerContainer {\n    border-top: none !important;\n}\n\n.MuiDataGrid-cell:focus {\n    outline: none !important;\n}\n\ndiv > svg[data-testid=\"CloseIcon\"] {\n    color: $COLOR_RED !important;\n}\n\ndiv > svg[data-testid=\"CheckIcon\"] {\n    color: $COLOR_PRIMARY_LIGHT !important;\n}\n\n.MuiPickersPopper-paper {\n    position: relative !important;\n    top: 56px !important;\n}\n\n.MuiDataGrid-menu {\n    z-index: 5000 !important;\n}\n\n.MuiDataGrid-panel {\n    z-index: 5001 !important;\n}\n\n.MuiDataGrid-cell {\n    border: 1px solid transparent !important;\n}\n\n.MuiDataGrid-cell:hover {\n    color: $COLOR_PRIMARY_LIGHT;\n}\n\n.MuiDataGrid-row:hover {\n    border: 1px solid $COLOR_PRIMARY_LIGHT !important;\n}\n\n/* Fix for black lines between table items */\n.MuiTableCell-root {\n    border-bottom: none !important;\n}\n","$COLOR_WHITE: get('colors.white');\n\n$COLOR_GREY_0: get('colors.grey0');\n$COLOR_GREY_1: get('colors.grey1');\n$COLOR_GREY_2: rgb(234, 234, 234);\n$COLOR_GREY_3: get('colors.grey3');\n$COLOR_PRIMARY_LIGHT: get('colors.material.primary.light');\n$COLOR_PRIMARY_MAIN: get('colors.material.primary.main');\n$COLOR_PRIMARY_DARK: get('colors.material.primary.dark');\n\n$COLOR_SECONDARY: get('colors.material.secondary.main');\n\n$COLOR_LIGHT_BLUE: #61B2B5;\n\n$LOCATIONGREEN0: get('colors.dam.locationGreen0');\n$LOCATIONGREEN1: get('colors.dam.locationGreen1');\n$LOCATIONGREEN2: get('colors.dam.locationGreen2');\n$LOCATIONGREEN3: get('colors.dam.locationGreen3');\n\n$COLOR_ORANGE: #FF7F00;\n$COLOR_RED: #e81d2c;\n$COLOR_YELLOW: get('colors.yellow');\n$COLOR_LIGHT_GREEN: get('colors.lightGreen');\n$COLOR_BLUE: get('colors.blue');\n\n$COLOR_DAM_BLUE: get('colors.dam.blue');\n$COLOR_DAM_DARKBLUE: get('colors.dam.darkBlue');\n$COLOR_DAM_LIGHTBLUE: get('colors.dam.lightBlue');\n$COLOR_DAM_ORANGE: get('colors.dam.orange');\n$COLOR_DAM_LIGHTGREEN: get('colors.dam.lightGreen');\n$COLOR_DAM_SEMIDARKGREEN: get('colors.dam.semiDarkGreen');\n\n$COLOR_DAMNOTCH_LIGHTBLUE: get('colors.dam.notchLightBlue');\n$COLOR_DAMNOTCH_BLUE: get('colors.dam.notchBlue');\n$COLOR_DAMNOTCH_DARKBLUE: get('colors.dam.notchDarkBlue');\n$COLOR_DAMNOTCH_LIGHTGREEN: get('colors.dam.notchLightGreen');\n$COLOR_DAMNOTCH_GREEN: get('colors.dam.notchGreen');\n$COLOR_DAMNOTCH_DARKGREEN: get('colors.dam.notchDarkgreen');\n\n$COLOR_POLE: get('colors.table.capturing.spu.pole');\n\n@import './style/customTableStyles.scss';\n\nbody {\n    position: absolute;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    font-family: 'Roboto', sans-serif;\n}\n\ninput, select, textarea, button{font-family:inherit;}\n\n#root {\n    height: 100% !important;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Flexbox */\n\n.flx1 { display: flex !important; flex: 1 !important; }\n.flx2 { display: flex !important; flex: 2 !important; }\n.flx3 { display: flex !important; flex: 3 !important; }\n.flx4 { display: flex !important; flex: 4 !important; }\n.flx5 { display: flex !important; flex: 5 !important; }\n\n.fdr {\n    display: flex !important;\n    flex-direction: row !important;\n    min-width: 0 !important;\n}\n.fdc {\n    display: flex !important;\n    flex-direction: column !important;\n    min-height: 0 !important;\n}\n\n.fdrr {\n    display: flex !important;\n    flex-direction: row-reverse !important;\n}\n.fdcr {\n    display: flex !important;\n    flex-direction: column-reverse !important;\n}\n\n.fww { display: flex !important; flex-wrap: wrap !important;}\n\n.aifs {\n    display: flex !important;\n    align-items: flex-start !important;\n}\n.aic {\n    display: flex !important;\n    align-items: center !important;\n}\n.aife {\n    display: flex !important;\n    align-items: flex-end !important;\n}\n.ais {\n    display: flex !important;\n    align-items: stretch !important;\n}\n\n.jcfs {\n    display: flex !important;\n    justify-content: flex-start !important;\n}\n.jcc {\n    display: flex !important;\n    justify-content: center !important;\n}\n.jcr {\n    display: flex !important;\n    justify-content: right !important;\n}\n.jcfe {\n    display: flex !important;\n    justify-content: flex-end !important;\n}\n.jcsa {\n    display: flex !important;\n    justify-content: space-around !important;\n}\n.jcsb {\n    display: flex !important;\n    justify-content: space-between !important;\n}\n.jcse {\n    display: flex !important;\n    justify-content: space-evenly !important;\n}\n\n.asc {\n    display: flex !important;\n    align-self: center !important;\n}\n\n.wsnw {\n    white-space: nowrap !important;\n}\n\n.tac {\n    text-align: center !important;\n}\n\n.cursorPointer { cursor: pointer !important;}\n\n.tdus {text-decoration: unset !important;}\n\n.gc2 {\n    display: grid;\n    grid-template-columns: auto auto;\n}\n\n.gc3 {\n    display: grid;\n    grid-template-columns: auto auto auto;\n}\n\n.gc4 {\n    display: grid;\n    grid-template-columns: auto auto auto auto;\n}\n\n/* Borders */\n\n.bwn {border: none !important;}\n.bw1 {border: 1px solid !important;}\n.brw1 {border-width: 0 1px 0 0; border-style:  solid !important;}\n.bbw1 {border-width: 0 0 1px 0; border-style: solid !important;}\n.bbw2 { border-bottom-width: 2px; }\n\n.bocp { border-color: $COLOR_PRIMARY_MAIN; }\n.bocg0 { border-color: $COLOR_GREY_0; }\n.bocg3 { border-color: $COLOR_GREY_3; }\n.bocw {border-color: white !important;}\n.bocDarkBlue {border-color: #052E5C !important;}\n.bocGrey {border-color: #CECECE !important;}\n.bocWhite {border-color: white !important;}\n\n.brh {border-radius: 50% !important;}\n.br0 {border-radius: 0px !important;}\n.br4 {border-radius: 4px !important;}\n.br5 {border-radius: 5px !important;}\n.br10 {border-radius: 10px !important;}\n.br15 {border-radius: 15px !important;}\n.br16 {border-radius: 16px !important;}\n.br17 {border-radius: 17px !important;}\n.br20 {border-radius: 20px !important;}\n.br25 {border-radius: 25px !important;}\n.br40 {border-radius: 40px !important;}\n.br50 {border-radius: 50px !important;}\n\n.pbr { border-radius: 4px 4px 0px 0px; }\n\n/* Dimensions */\n.wfill {width: 100% !important;}\n.wfillMinusScroll {width: calc(100% - 8.5px) !important;}\n.w0 {width: 0 !important;}\n.w1 {width: 1px !important;}\n.w2 {width: 2px !important;}\n.w3 {width: 3px !important;}\n.w5 {width: 5px !important;}\n.w10 {width: 10px !important;}\n.w20 {width: 20px !important;}\n.w23 {width: 23px !important;}\n.w30 {width: 30px !important;}\n.w37 {width: 37px !important;}\n.w40 {width: 40px !important;}\n.w42 {width: 42px !important; min-width: 42px !important;}\n.w45 {width: 45px !important; min-width: 45px !important;}\n.w50 {width: 50px !important;}\n.w56 {width: 56px !important; min-width: 56px !important;}\n.w60 {width: 60px !important; min-width: 60px !important;}\n.w65 {width: 65px !important; min-width: 65px !important;}\n.w77 {width: 77px !important; min-width: 77px !important;}\n.w100 {width: 100px !important;}\n.w120 {width: 120px !important;}\n.w150 {width: 150px !important;}\n.w172 {width: 172px !important;}\n.w180 {width: 180px !important;}\n.maw180 {max-width: 180px !important;}\n.w200 {width: 200px !important;}\n.w205 {width: 205px !important;}\n.w240 {width: 240px !important;}\n.w250 {width: 250px !important;}\n.w290 {width: 290px !important;}\n.w300 {width: 300px !important;}\n.w320 {width: 320px !important;}\n.w338 {width: 338px !important;}\n.w350 {width: 350px !important;}\n.w400 {width: 400px !important;}\n.w500 {width: 500px !important;}\n.w600 {width: 600px !important;}\n.w700 {width: 700px !important;}\n.w800 {width: 800px !important;}\n.w804 {width: 804px !important;}\n.w900 {width: 900px !important;}\n.w1000 {width: 1000px !important;}\n.w1200 {width: 1200px !important;}\n.w1500 {width: 1500px !important;}\n\n.mw0 {min-width: 40px !important;}\n.mw40 {min-width: 40px !important;}\n.mw100 {min-width: 100px !important;}\n.mw160 {min-width: 160px !important;}\n.mw200 {min-width: 200px !important;}\n.mw300 {min-width: 300px !important;}\n.mw600 {min-width: 600px !important;}\n.mw800 {min-width: 800px !important;}\n.mw900 {min-width: 900px !important;}\n\n.hfill {height: 100% !important;}\n.hauto {height: auto !important;}\n.h0 {height: 0 !important;}\n.mh0 {min-height: 0 !important;}\n.h2 { height: 2px !important; }\n.h3 { height: 3px !important; }\n.mnh4 {min-height: 4px !important;}\n.h6 { height: 6px !important; }\n.h10 {height: 10px !important;}\n.h20 {height: 20px !important;}\n.h23 {height: 23px !important;}\n.mnh20 {min-height: 20px !important;}\n.mnh24 {min-height: 24px !important;}\n.h30 {height: 30px !important;}\n.h31 {height: 31px !important;}\n.h32 {height: 32px !important;}\n.mnh32 {min-height: 32px !important;}\n.h35 {height: 35px !important;}\n.h37 {height: 37px !important;}\n.h40 {height: 40px !important;}\n.h42 {height: 42px !important;}\n.h48 {height: 48px !important;}\n.mnh48 {min-height: 48px !important;}\n.h50 {height: 50px !important;}\n.h52 {height: 52px !important; min-height: 52px !important;}\n.mxh52 {max-height: 52px !important;}\n.mnh55 {min-height: 55px !important;}\n.h60 {height: 60px !important;}\n.mnh65 {min-height: 65px !important;}\n.h70 {height: 70px !important;}\n.mnh100 {min-height: 100px !important;}\n.h120 {height: 120px !important;}\n.mh135 {min-height: 135px !important;}\n.h138 {height: 138px !important;}\n.mxh120 {max-height: 120px !important;}\n.h150 {height: 150px !important;}\n.h155 {height: 155px !important;}\n.h200 {height: 200px !important;}\n.mh200 {min-height: 200px !important;}\n.h240 {height: 240px !important;}\n.mnh200 {min-height: 200px !important;}\n.mxh200 {max-height: 200px !important;}\n.h250 {height: 250px !important;}\n.mnh250 {min-height: 250px !important;}\n.h260 {height: 260px !important;}\n.h225 {height: 225px !important;}\n.h265 {height: 265px !important;}\n.h275 {height: 275px !important;}\n.mxh300 {max-height: 300px !important;}\n.mnh350 {min-height: 350px !important;}\n.h400 {height: 400px !important;}\n.mxh400 {max-height: 400px !important;}\n.mxhi {max-height: inherit !important;}\n.h800 {height: 800px !important;}\n.mxh600 {max-height: 600px !important;}\n.h1132 { height: 1132px; }\n\n.m5 {margin: 5px !important;}\n.m10 {margin: 10px !important;}\n.m20 {margin: 20px !important;}\n.m50 {margin: 50px !important;}\n\n.ml4 {margin-left: 4px !important;}\n.ml7 {margin-left: 7px !important;}\n.ml10 {margin-left: 10px !important;}\n.ml15 {margin-left: 15px !important;}\n.ml17 {margin-left: 17px !important;}\n.ml20 {margin-left: 20px !important;}\n.ml25 {margin-left: 25px !important;}\n.ml30 {margin-left: 30px !important;}\n.ml38 {margin-left: 38px !important;}\n.ml40 {margin-left: 40px !important;}\n.ml50 {margin-left: 50px !important;}\n.ml240 {margin-left: 240px !important;}\n\n.mr4 {margin-right: 4px !important;}\n.mr5 {margin-right: 5px !important;}\n.mr7 {margin-right: 7px !important;}\n.mr8 {margin-right: 8px !important;}\n.mr10 {margin-right: 10px !important;}\n.mr15 {margin-right: 15px !important;}\n.mr16 {margin-right: 16px !important;}\n.mr17 {margin-right: 17px !important;}\n.mr18 {margin-right: 18px !important;}\n.mr20 {margin-right: 20px !important;}\n.mr25 {margin-right: 25px !important;}\n.mr30 {margin-right: 30px !important;}\n.mr40 {margin-right: 40px !important;}\n.mr50 {margin-right: 50px !important;}\n.mr240 {margin-right: 240px !important;}\n\n.mrnlc15:not(:last-child) {margin-right: 15px !important;}\n\n.mt5 {margin-top: 5px !important;}\n.mt8 {margin-top: 8px !important;}\n.mt9 {margin-top: 9px !important;}\n.mt10 {margin-top: 10px !important;}\n.mt12 {margin-top: 12px !important;}\n.mt14 {margin-top: 14px !important;}\n.mt15 {margin-top: 15px !important;}\n.mt16 {margin-top: 16px !important;}\n.mt20 {margin-top: 20px !important;}\n.mt21 {margin-top: 21px !important;}\n.mt23 {margin-top: 23px !important;}\n.mt26 {margin-top: 26px !important;}\n.mt30 {margin-top: 30px !important;}\n.mt40 {margin-top: 40px !important;}\n.mt50 {margin-top: 50px !important;}\n.mt240 {margin-top: 240px !important;}\n\n.mbm16 {margin-bottom: -16px !important;}\n.mb1 {margin-bottom: 1px !important;}\n.mb5 {margin-bottom: 5px !important;}\n.mb3 {margin-bottom: 3px !important;}\n.mb8 {margin-bottom: 8px !important;}\n.mb10 {margin-bottom: 10px !important;}\n.mb12 {margin-bottom: 12px !important;}\n.mb13 {margin-bottom: 13px !important;}\n.mb15 {margin-bottom: 15px !important;}\n.mb20 {margin-bottom: 20px !important;}\n.mb30 {margin-bottom: 30px !important;}\n.mb40 {margin-bottom: 40px !important;}\n.mb50 {margin-bottom: 50px !important;}\n.mb60 {margin-bottom: 60px !important;}\n.mb70 {margin-bottom: 70px !important;}\n.mb145 {margin-bottom: 145px !important;}\n.mb240 {margin-bottom: 240px !important;}\n\n.p0 {padding: 0 !important;}\n.p1 {padding: 1px !important;}\n.p5 {padding: 5px !important;}\n.p10 {padding: 10px !important;}\n.p12 {padding: 12px !important;}\n.p15 {padding: 15px !important;}\n.p20 {padding: 20px !important;}\n.p30 {padding: 30px !important;}\n.p40 {padding: 30px !important;}\n.p50 {padding: 50px !important;}\n\n.pr0 {padding-right: 0 !important;}\n.pr5 {padding-right: 5px !important;}\n.pr10 {padding-right: 10px !important;}\n.pr15 {padding-right: 15px !important;}\n.pr20 {padding-right: 20px !important;}\n.pr24 {padding-right: 24px !important;}\n.pr25 {padding-right: 25px !important;}\n.pr30 {padding-right: 30px !important;}\n.pr36 {padding-right: 36px !important;}\n.pr50 {padding-right: 50px !important;}\n.pr80 {padding-right: 80px !important;}\n.pr109 {padding-right: 109px !important;}\n\n.pl0 {padding-left: 0px !important;}\n.pl1 {padding-left: 1px !important;}\n.pl2 {padding-left: 2px !important;}\n.pl5 {padding-left: 5px !important;}\n.pl10 {padding-left: 10px !important;}\n.pl15 {padding-left: 15px !important;}\n.pl20 {padding-left: 20px !important;}\n.pl25 {padding-left: 25px !important;}\n.pl30 {padding-left: 30px !important;}\n.pl50 {padding-left: 50px !important;}\n.pl80 {padding-left: 80px !important;}\n.pl109 {padding-left: 109px !important;}\n\n.pt3 {padding-top: 3px !important;}\n.pt5 {padding-top: 5px !important;}\n.pt8 {padding-top: 8px !important;}\n.pt10 {padding-top: 10px !important;}\n.pt15 {padding-top: 15px !important;}\n.pt16 {padding-top: 16px !important;}\n.pt20 {padding-top: 20px !important;}\n.pt28 {padding-top: 28px !important;}\n.pt30 {padding-top: 30px !important;}\n.pt50 {padding-top: 50px !important;}\n\n.pb0 {padding-bottom: 0px !important;}\n.pb3 {padding-bottom: 3px !important;}\n.pb4 {padding-bottom: 4px !important;}\n.pb5 {padding-bottom: 5px !important;}\n.pb7 {padding-bottom: 7px !important;}\n.pb8 {padding-bottom: 8px !important;}\n.pb10 {padding-bottom: 10px !important;}\n.pb15 {padding-bottom: 15px !important;}\n.pb16 {padding-bottom: 16px !important;}\n.pb20 {padding-bottom: 20px !important;}\n.pb24 {padding-bottom: 24px !important;}\n.pb28 {padding-bottom: 28px !important;}\n.pb30 {padding-bottom: 30px !important;}\n.pb50 {padding-bottom: 50px !important;}\n\n.oh {overflow: hidden !important;}\n.oyh {overflow-y: hidden !important;}\n.oys {overflow-y: scroll !important;}\n.oya {overflow-y: auto !important;}\n.oxs {overflow-x: scroll !important;}\n.oxh {overflow-x: hidden !important;}\n.ov {overflow: visible !important;}\n.oa {overflow: auto !important;}\n.oyo {overflow-y: overlay !important;}\n\n.hidescroll::-webkit-scrollbar { display: none !important;}\n\n.posr {position: relative !important;}\n.posa {position: absolute !important;}\n.posf {position: fixed !important;}\n\n.post0 {top: 0 !important;}\n.post10 {top: 10 !important;}\n.posr0 {right: 0 !important;}\n.posb0 {bottom: 0 !important;}\n.posl0 {left: 0 !important;}\n.post30 {top: 30px !important;}\n.posl40 {left: 40px !important;}\n\n.posr200 {right: 200px !important;}\n\n.postn17 {top: -17px !important;}\n.post20n {top: -50px !important;}\n.post46 {top: 46px !important;}\n.post70 {top: 70px !important;}\n.post90 {top: 90px !important;}\n\n.dn {display: none !important;}\n\n.zi0 {z-index: 0 !important;}\n.zi1 {z-index: 1 !important;}\n.zi2 {z-index: 2 !important;}\n.zi3 {z-index: 3 !important;}\n.zi100 {z-index: 100 !important;}\n.zi500 {z-index: 500 !important;}\n.zi1000 {z-index: 1000 !important;}\n.zi2500 {z-index: 2500 !important;}\n.zi9999 {z-index: 9999 !important;}\n\n.cp {color: $COLOR_PRIMARY_MAIN !important;}\n.cw {color: white !important;}\n.cs {color: $COLOR_SECONDARY !important;}\n.cdg {color: #0b4323 !important;}\n.cpd {color: #0b4323 !important;}\n.cr {color: $COLOR_RED !important;}\n.cg1 {color: $COLOR_GREY_1 !important;}\n.cg2 {color: $COLOR_GREY_2 !important;}\n.cg3 {color: $COLOR_GREY_3 !important;}\n.cg4 {color: #0000008a !important;}\n.cy {color: $COLOR_YELLOW !important;}\n.cb {color: black !important;}\n.cpo {color: $COLOR_POLE}\n\n.bcp {background-color: $COLOR_PRIMARY_MAIN !important;}\n.bcpl {background-color: $COLOR_PRIMARY_LIGHT !important;}\n.bcpd {background-color: $COLOR_PRIMARY_DARK !important;}\n.bcw {background-color: white !important;}\n.bcr {background-color: #e81d2c !important;}\n.bco {background-color: $COLOR_ORANGE !important;}\n.bcy {background-color: #fddb00 !important;}\n.bclg {background-color: $COLOR_LIGHT_GREEN !important;}\n.bcb {background-color: $COLOR_BLUE !important;}\n.bcblack {background-color: #000 !important;}\n.bcDarkBlue {background-color: #052E5C !important;}\n.tcDarkBlue {color: #052E5C !important;}\n.tcGreen {color: #168944 !important;}\n.bcGreen {background-color: #168944 !important;}\n.bcDarkRed {background-color: darkred !important;}\n.bcLightBlue {background-color: #2294FC !important;}\n.bcGrey {background-color: #F0F5F7 !important;}\n.tcOrange {color: #f79d33 !important;}\n.bcg0 {background-color: $COLOR_GREY_0 !important;}\n.bcg1 {background-color: $COLOR_GREY_1 !important;}\n.bcg2 {background-color: $COLOR_GREY_2 !important;}\n.bcg3 {background-color: $COLOR_GREY_3 !important;}\n.bct {background-color: transparent !important;}\n.bclb {background-color: $COLOR_LIGHT_BLUE !important;}\n\n.bcdlg0{background-color: $LOCATIONGREEN0 !important;}\n.bcdlg1{background-color: $LOCATIONGREEN1 !important;}\n.bcdlg2{background-color: $LOCATIONGREEN2 !important;}\n.bcdlg3{background-color: $LOCATIONGREEN3 !important;}\n\n.dbcb {background-color: $COLOR_DAM_BLUE !important;}\n.dbcdb {background-color: $COLOR_DAM_DARKBLUE !important;}\n.dbclb {background-color: $COLOR_DAM_LIGHTBLUE !important;}\n.dbco {background-color: $COLOR_DAM_ORANGE !important;}\n.dbclg {background-color: $COLOR_DAM_LIGHTGREEN !important;}\n.dbcsdg {background-color: $COLOR_DAM_SEMIDARKGREEN !important;}\n\n.dvblb{background-color: $COLOR_DAMNOTCH_LIGHTBLUE !important;}\n.dvbb{background-color: $COLOR_DAMNOTCH_BLUE !important;}\n.dvbdb{background-color: $COLOR_DAMNOTCH_DARKBLUE !important;}\n.dvblg{background-color: $COLOR_DAMNOTCH_LIGHTGREEN !important;}\n.dvbg{background-color: $COLOR_DAMNOTCH_GREEN !important;}\n.dvbdg{background-color: $COLOR_DAMNOTCH_DARKGREEN !important;}\n\n.dco {color: $COLOR_DAM_ORANGE !important;}\n\n.dcgrey{color: #757575 !important;}\n\n.fw300{font-weight: 300 !important;}\n.fwr {font-weight: 400 !important;}\n.fw400 {font-weight: 400 !important;}\n.fwm {font-weight: 500 !important;}\n.fw500 {font-weight: 500 !important;}\n.fw600 {font-weight: 600 !important;}\n.fwb {font-weight: 700 !important;}\n.fw700 {font-weight: 700 !important;}\n\n.usn { user-select: none }\n\n.fs8 {font-size: 8px !important;}\n.fs10 {font-size: 10px !important;}\n.fs11 {font-size: 11px !important;}\n.fs12 {font-size: 12px !important;}\n.fs13 {font-size: 13px !important;}\n.fs14 {font-size: 14px !important;}\n.fs15 {font-size: 15px !important;}\n.fs16 {font-size: 16px !important;}\n.fs18 {font-size: 18px !important;}\n.fs19 {font-size: 19px !important;}\n.fs20 {font-size: 20px !important;}\n.fs23 {font-size: 23px !important;}\n.fs25 {font-size: 25px !important;}\n.fs28 {font-size: 28px !important;}\n.fs30 {font-size: 30px !important;}\n.fs32 {font-size: 32px !important;}\n.fs36 {font-size: 36px !important;}\n.fs40 {font-size: 40px !important;}\n.fs41 {font-size: 41px !important;}\n.fs45 {font-size: 45px !important;}\n.fs46 {font-size: 46px !important;}\n.fs50 {font-size: 50px !important;}\n\n.ftu {\n    text-transform: uppercase;\n}\n.lh40 {\n    line-height: 40px;\n}\n\n.lh37 {\n    line-height: 37px;\n}\n\n.ls065 {\n    letter-spacing: 0.65px;\n}\n\n.ls09 {\n    letter-spacing: 0.9px;\n}\n\n.curp {\n    cursor: pointer;\n}\n\n/* Random */\n\n.materialCell {\n    float:left;\n\n}\n\n.TextField {\n    min-height: 48px !important;\n    float: left;\n    width: 100%;\n}\n\n.DropDown {\n    float: left;\n    width: 100%;\n}\n\n.detailsEditing {\n    background-color: darkcyan !important;\n    color: white !important;\n}\n\n.DisplayFieldToRight {\n    padding-top: 4px !important;\n    padding-bottom: 3px !important;\n}\n\n.DisplayFieldBottom {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n}\n\n.DisplayFieldBottomWithSupText {\n    margin-top: -1px !important;\n    padding-bottom: 3px !important;\n}\n\n\n.DropDownDisplayFieldBottom {\n    padding-bottom: 20px !important;\n    padding-top: 4px !important;\n}\n\n.TransformerMeterNumberReadingsTextField {\n    height: 32px !important;\n    max-width: 112px !important; \n}\n\n.TransformerMeterNumberReadingsDisplayField {\n    font-size: 1rem !important;\n    padding-top: 4px !important;\n}\n\n.GridDetailsDropDown {\n    width: calc(100vw - 80px) !important;\n}\n\n.Dropzone {\n    width: 196px;\n    height: 146px;\n    position: relative;\n    border-width: 2px;\n    border-color: rgb(102, 102, 102);\n    border-style: dashed;\n    border-radius: 5px;\n}\n\n.ThumbSize {\n    max-width: 200px;\n    height: 150px;\n}\n\n.ImagePreview {\n    max-width: 100%;\n    max-height: 100%;    \n}\n\n.ImageArea {\n    max-height: 200px;\n    height: 200px;\n    justify-content: center;\n    text-align: center;\n    flex-direction: row;\n}\n\n.TitleSelect {\n    font-size: 1.3125rem !important;\n    font-weight: 500 !important;\n    margin-top: -6px !important;\n    margin-bottom: -7px !important;\n}\n\n.TitleSelect::before {\n    border-bottom-width: 0px !important;\n    border-bottom-color: white !important;\n}\n\n.TitleSelect::after {\n    border-bottom-width: 0px !important;\n    border-bottom-color: white !important;\n}\n\n.PromptButton {\n    background-color: white !important;\n    color: black !important;\n    min-width: 86px !important;\n}\n\n.PromptButton:hover {\n    opacity: .6 !important;\n}\n\n.PromptButton:focus {\n    background-color: #168944 !important;\n    color: white !important;\n}\n\n.PromptButton[type=submit] {\n    background-color: #168944 !important;\n    color: white !important;\n}\n\n.VerticalText {    \n    writing-mode: tb !important;\n    -webkit-transform: rotate(180deg) !important;\n    -moz-transform: rotate(180deg) !important;\n    -ms-transform: rotate(180deg) !important;\n    -o-transform: rotate(180deg) !important;\n    transform: rotate(180deg) !important;\n}\n\n.RoundedCorners {\n    border-radius: 10px\n}\n\n.NewDesignDisplayField {\n    font-size: 1rem !important;\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif !important;\n    line-height: 1.1875em !important;\n    padding-top: 6px !important;\n    padding-bottom: 7px !important;\n}\n\n.NewDesignDisplayFieldWithSup {\n    font-size: 1rem !important;\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif !important;\n    line-height: 1.1875em !important;\n    padding-top: 1px !important;\n    padding-bottom: 12px !important;\n}\n\ndiv.CalibrationTestTable::-webkit-scrollbar {\n    height: 10px;\n}\n\ndiv.CalibrationTestTable::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey; \n    border-radius: 10px;\n    padding-right: 5px;\n}\n\ndiv.CalibrationTestTable::-webkit-scrollbar-thumb {\n    background: #1e4776; \n    border-radius: 10px;\n}\n\ndiv.CalibrationTestTable::-webkit-scrollbar-thumb:hover {\n    background: #052e5c; \n}\n\n\n/** SCROLL **/\n.drawer::-webkit-scrollbar {\n    width: 5px;\n    border-radius: 5px;\n}\n\n.drawer::-webkit-scrollbar-track {\n    background: $COLOR_GREY_0;\n}\n  \n/* Handle */\n.drawer::-webkit-scrollbar-thumb {\n    background: $COLOR_PRIMARY_MAIN;\n}\n  \n/* Handle on hover */\n.drawer::-webkit-scrollbar-thumb:hover {\n    background: $COLOR_PRIMARY_DARK;\n}\n\n/**toggleStadiumButton**/\n\n/* Handles the background of the toggleStadiumButton */\n.toggleStadiumButtonSelected {\n    background-color: $COLOR_PRIMARY_MAIN !important;\n    color: white !important;\n}\n.toggleStadiumButtonUnselected {\n    background-color: #fd0 !important;\n    color: $COLOR_PRIMARY_MAIN !important;\n}  \n\n.toggleStadiumButtonIconSelected {\n    background-color: $COLOR_PRIMARY_MAIN !important;\n}\n.toggleStadiumButtonIconUnselected {\n    background-color: #fd0 !important;\n}\n  \n/* Handles the background of the toggleStadiumButton on hover */\n.toggleStadiumButtonSelected:hover {\n    background-color: $COLOR_PRIMARY_DARK !important; \n}\n\n.toggleStadiumButtonUnselected:hover {\n    background-color: #dbbe00 !important;\n}\n\n.mximg img {\n    max-height: 130px !important;\n}\n.dam-summary-Heading{\n    font-size: 12px !important;\n    color:rgb(102, 102, 102);\n    display: flex;\n    flex: 1;\n}\n\n.dam-summary-detail{\n    font-size: 14px !important;\n    display: flex;\n    flex: 1;\n    font-weight: 700;\n}\n\n.rotate{\n    writing-mode: vertical-rl;\n    text-orientation:sideways-left;\n}\n\n.file-card-backdrop::before {\n    content: \"\";\n    background-size: cover;\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n    background: #000000 0% 0% no-repeat padding-box;\n    opacity: 0.61;\n}\n\ndiv.hidden {\n    visibility: hidden;\n}\n\ndiv.hidden:hover {\n    visibility: visible;\n}\n.fab.save {\n    background-color: #fd0;\n    color: #004b22;\n    min-width: 100px !important;\n}\n.fab.save:hover {\n    background-color: #fd3;\n}\n.fab.save > span:nth-child(1) {\n    padding: 0px 15px;\n}\n.fab.cancel {\n    background-color: transparent;\n    color: #004b22;\n    box-shadow: none;\n    min-width: 100px !important;\n}\n\n.rdrDay {\n    color : #168944 !important;\n}\n\n.rdrStartEdge {\n    color : #168944 !important;\n}\n\n.rdrEndEdge {\n    color : #168944 !important;\n}\n\n.rdrInRange {\n    color : #168944 !important;\n}\n\n.rdrStaticRangeLabel {\n    color : #168944 !important;\n}\n\n.rdrDateDisplay {\n    color : #168944 !important;\n}\n\n.rdrDayToday {\n    color : #168944 !important;\n}\n\n.rdrDayToday .rdrDayNumber span:after {\n    background : #168944 !important;\n}\n\n.rdrDayToday .rdrInRange ~ .rdrDayNumber span:after, .rdrDayToday .rdrStartEdge ~ .rdrDayNumber span:after, .rdrDayToday .rdrEndEdge ~ .rdrDayNumber span:after, .rdrDayToday .rdrSelected ~ .rdrDayNumber span:after {\n    background : #fff !important;\n}\n\n.rdrDayStartPreview {\n    color : #168944 !important;\n}\n\n.rdrDayEndPreview {\n    color : #168944 !important;\n}\n\n.rdrDayInPreview {\n    color : #168944 !important;\n}\n\n.rdrSelected {\n    color : #168944 !important;\n}\n\n/* Breadcrumbs */\n\n.breadcrumbLink {\n    color: inherit !important;\n    text-decoration: none !important;\n}\n\n.breadcrumbLink:hover {\n    color: inherit !important;\n    text-decoration: underline !important;\n}\n\n/* side menu item component */\n\n.sideMenuButton:hover {\n    background-color: rgba(0, 0, 0, 0.04) !important;\n}\n\n/* nav drawer */\n\n.disableImageDrag {\n    -webkit-user-drag: none;\n}\n\n.filterShadow {box-shadow: 0px 3px 6px $COLOR_GREY_3 !important}\n\n/* scrolling */\n\ndiv.scroll-area::-webkit-scrollbar {\n    height: 7px;\n}\n\ndiv.scroll-area::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px white;\n    border-radius: 10px;\n}\n\ndiv.scroll-area::-webkit-scrollbar-thumb {\n    background: $COLOR_PRIMARY_MAIN;\n    border-radius: 10px;\n}\n\ndiv.scroll-area::-webkit-scrollbar-thumb:hover {\n    background: #1b6337;\n}\n\n\n$scrollbar-track-color: #f1f1f1;\n$scrollbar-thumb-color: #bbbbbb;\n$scrollbar-thumb-hover-color: #979797;\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  scrollbar-width: thin;\n}\n\n::-webkit-scrollbar-track {\n  background: $COLOR_WHITE;\n}\n\n::-webkit-scrollbar-thumb {\n  background: $scrollbar-thumb-color;\n  border-radius: 4px;\n  \n  &:hover {\n    background: $scrollbar-thumb-hover-color;\n  }\n}\n\n/* login */\n\n.blur {backdrop-filter: blur(15px)}\n\n.login-card-background {background: rgba(0, 0, 0, 0.3) !important;}\n\n/* Change default input underline to primary green */\n.MuiInput-underline:before {\n  border-bottom-color: $COLOR_PRIMARY_MAIN !important;\n}\n\n/* Font Style */\n.fsi {\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
